import { isDefinedArray } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import { TSelectionPages } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import getKhattabat101MGeneralStore from "../../../../stores/khattabat-stores/101m-stores/general-101m-store";

const IgnoreConversation = withLiteObserverAndTheme<{
  pageType: TSelectionPages;
  matchIDs: number[];
  hasOneOTwoWithClient: boolean;
}>((props) => {
  const { matchIDs, pageType, hasOneOTwoWithClient, theme } = props;
  const { colors, unitX, unitY } = theme;
  const shouldShow = pageType === "matchResultPage";
  const shouldEnable = isDefinedArray(matchIDs) && !hasOneOTwoWithClient;

  return !shouldShow ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={150}
      height={35}
      color={colors.all.transparent}
      style={{
        borderRadius: 10 * unitX,
        backgroundColor: shouldEnable ? colors.all.red : colors.all.dimGray,
        cursor: "pointer"
      }}
      onClick={async () =>
        shouldEnable
          ? await getKhattabat101MGeneralStore().ignoreMatchConversationDatabase(
              {
                matchIDs
              }
            )
          : null
      }
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={15}
        isSpan={true}
        text={i18n.get("IGNORE")}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 30 * unitY,
          width: "100%"
        }}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default IgnoreConversation;
